export default __webpack_public_path__ + "static/media/InvestTablet.0b2a2976.png";